import { useState, useEffect } from "react";
import Button from "../button/Button.jsx";
import { useSelector, useDispatch } from "react-redux";
import {updateState} from "../../redux-state/disclaimerHandler.js";
function Modal(){
    const dispatch = useDispatch();
    
    function toggleDeclineButton(){
        let checkbox = document.getElementById('disclaimer-check-remember').checked;
        let declineBtn = document.getElementById('button-decline');
        let checkTxt = document.getElementById("disclaimer-check-remember-txt");
        if(checkbox){
            declineBtn.disabled = true;
            declineBtn.classList.add('btn-disabled');
            declineBtn.classList.remove('btn-decline');
            checkTxt.style.color = "#3367BC";
        }else{
            declineBtn.disabled = false;
            declineBtn.classList.add('btn-decline');
            declineBtn.classList.remove('btn-disabled');
            checkTxt.style.color = "#222222";
        }
    }

    function modalHandling(selection){
        let checkbox = document.getElementById('disclaimer-check-remember').checked;
        if(selection && checkbox){
            document.cookie = 'disclaimer-calc-accept=true; expires='+new Date(9999,0,1).toUTCString();
            dispatch(
                updateState({
                  disclaimerSigned:  true,
                  })
                );
        }else if(selection){
            sessionStorage.setItem('disclaimer-calc-accept', 'true');
dispatch(
        updateState({
          disclaimerSigned:  true,
          })
        );
        }else{
            sessionStorage.setItem('disclaimer-calc-accept', 'false');
            dispatch(
                updateState({
                  disclaimerSigned:  true,
                  })
                );
        }
    }

    return(  
    // <div
    //     id={"popUp-display"}
    //     // onClick={() => hidePopUpVisibility()}
    //   >
    //     <div className="popUp-container">
    
    <div id="disclaimer-container">
        <div id="modal-popUp">
            <h1>Disclaimer</h1>
            <p id="modal-txt">To avoid additional charges, please ensure price entered will match pricing on portals. If the property price on the portal exceeds the selected price band, additional portal charges will be passed on to your campaign at your cost.
            <br />
            <br />
            PMA charges apply and are calculated on total marketing schedule.
            <br />
            <br />
            Domain Social Boost can only be removed if property value &lt; $2.25m.
            <br />
            <br />
             Any downgrades must be communicated to the Property Marketing team when property is launched online.</p>
            <div className="dislaimer-check">
            <input type="checkbox" name="disclaimer" id="disclaimer-check-remember" onInput={()=>toggleDeclineButton()}/>
            <label id="disclaimer-check-remember-txt" htmlFor="disclaimer-check-remember" className="default-txt-checkbox">Remember my selection</label>
            </div>
            <div className="modal-buttons">
                <Button
                                          onClickMethod={() =>
                                            modalHandling(true)
                                          }
                                          id={""}
                                          classes={"btn-accept btn-structure"}
                                          buttonTxt={"Accept"}
                                          desc={"Accept"}
                                          disabled={false}
                                        />
                                        <Button
                                          onClickMethod={() =>
                                            modalHandling(false)
                                          }
                                          id={"button-decline"}
                                          classes={"btn-decline btn-structure"}
                                          buttonTxt={"Decline"}
                                          desc={"Decline"}
                                          disabled={false}
                                        />
                {/* <button className="button button-accept" onClick={()=> modalHandling(true)}>Accept</button>
                <button id="button-decline" className="button button-decline" onClick={()=> modalHandling(false)}>Decline</button> */}
            </div>
        </div>
        <div className="popUp-disclaimer-bg" onClick={() => modalHandling(false)}></div>
        </div>
    )
}

export default Modal